import { Route } from "@angular/router";
import { AuthGuard } from "@/common/guards/auth.guard";
import { PagenotfoundComponent } from "@/modules/errors/pagenotfound/pagenotfound.component";
import { VALID_OPERATOR_ROLES } from "@shared/user.constants";

export const APP_ROUTES: Route[] = [
  {
    path: "",
    loadChildren: () => import("@/modules/marketing/marketing.module").then((m) => m.MarketingModule),
    canActivate: [AuthGuard],
  },
  {
    path: "member",
    loadChildren: () => import("@/modules/member/member.module").then((m) => m.MemberModule),
    canActivate: [AuthGuard],
  },
  {
    path: "admin",
    loadChildren: () => import("@/modules/admin/admin.module").then((m) => m.AdminModule),
    canActivate: [AuthGuard],
    data: {
      roles: VALID_OPERATOR_ROLES,
      cssClass: "admin-module",
    }
  },
  {
    path: "**",
    pathMatch: "full",
    canActivate: [],
    component: PagenotfoundComponent,
    data: {
      title: "Page Not Found",
      roles: []
    }
  },
];
